// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { EllipsisVertical as RawEllipsisVertical } from "lucide-react";
export const EllipsisVertical = /* @__PURE__ */ createIcon(RawEllipsisVertical, "EllipsisVertical", 2);
